<script setup>
    import {ref} from "vue";
    import Modal from "@/components/Modal.vue";
    import SwitchDivs from "@/components/SwitchDivs.vue";
    import authService from "@/services/authService";

    const activeIndex = ref(0);
    const userName = ref("");
    const password = ref("");
    const email = ref("");

    const errorMessage = ref("");

    function submitRegistration(){
        if(userName.value.length > 0 && password.value.length > 0 && email.value.length > 0){
            authService.initiateSignup(userName.value, password.value, email.value).then(() =>{
                activeIndex.value = 1;
            }).catch((e)=>{
                console.log({e:e});
                console.log({e:e.message});
                errorMessage.value = e.message;
                console.log(errorMessage.value);
                activeIndex.value = 2;
            })
            
        }
    }

</script>


<template>
    <Modal>
        <SwitchDivs :activePage = "activeIndex">
            <div>
                <form @submit.prevent = "submitRegistration">
                <ul>
                    <li>Username: <input v-model = "userName" /></li>
                    <li>Password: <input type="password" v-model = "password"/></li>
                    <li>Email: <input type = "email" v-model = "email"/></li>
                </ul>
                <button >Submit</button>
                </form>
                <div><router-link to="/">or go back to login</router-link></div>
            </div>    
            <div>Thank you. An confirmation email has been sent to your email account.</div>
            <div><div>Error: {{errorMessage}}</div><div><button @click = "activeIndex = 0">Go back</button></div></div>
        </SwitchDivs>
    </Modal>
        

</template>

<style scoped>
li{
      list-style-type: none;
}

</style>